
export interface ToastConfig {
  icon: string;
  iconColor: string;
  content: string;
  showUndo: boolean;
  msg?: string;
}
